import { useAuth } from "@/lib/auth";
import { supabase } from "@/integrations/supabase/client";
import { useQuery } from "@tanstack/react-query";

export interface BusinessProfile {
  business_name?: string;
  business_slug?: string;
  website_url?: string;
  business_logo_url?: string;
}

export function useBusinessProfile() {
  const { user } = useAuth();

  const { data: businessProfile, isLoading, error } = useQuery({
    queryKey: ['business-profile', user?.id],
    queryFn: async (): Promise<BusinessProfile | null> => {
      if (!user) {
        return null;
      }
      
      const { data, error } = await supabase
        .from("profiles")
        .select("business_name, business_slug, website_url, business_logo_url")
        .eq("id", user.id)
        .maybeSingle();

      if (error) {
        console.error('Error fetching business profile:', error);
        throw error;
      }
      
      return data;
    },
    enabled: !!user,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });

  return {
    businessProfile,
    isLoading,
    error,
    websiteUrl: businessProfile?.website_url
  };
}